<template>
	<Tabs :value="value" class="ilab-tabs" :animated="false" @on-click="onTabsClick">
		<TabPane v-for="item in tabPanes" :key="item.name" :label="item.label" :name="item.name"> </TabPane>
	</Tabs>
</template>
<script>
	export default {
		name: 'NeoTabs',
		props: {
			value: {
				type: String,
				default: '',
			},
			tabPanes: {
				type: Array,
				default() {
					return [];
				},
			},
		},
		methods: {
			onTabsClick(name) {
				this.$emit('input', name);
				this.$emit('on-tabs-click', name);
			},
		},
	};
</script>
